var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"v2-events-redirect"},[_c('v-icon',{attrs:{"size":"32","color":"grey lighten-1"}},[_vm._v("mdi-progress-clock")]),_c('p',{staticClass:"v2-body v2-body--sm v2-body--muted"},[_vm._v("Redirigiendo…")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }